import { render } from "./DialogTable.vue?vue&type=template&id=bb426d8c&scoped=true"
import script from "./DialogTable.vue?vue&type=script&lang=js"
export * from "./DialogTable.vue?vue&type=script&lang=js"

import "./DialogTable.vue?vue&type=style&index=0&id=bb426d8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb426d8c"]])

export default __exports__